import { GameStatus } from '@betterpool/api-types/games-service';

import type { PlayerPoolMember } from '~/domains/contest/domains/services/interfaces/player-pool-member.interface';
import type { PickForEntry } from '~/domains/contest/domains/services/interfaces/picks-for-entry.interface';
import type { PlayerDetail } from '~/domains/games/interfaces/player-detail.interface';

import type { PlayerInfo } from '../../types/player';

import parseNonScheduledTeamSport from './parseNonScheduledTeamSport';
import parseScheduledTeamSport from './parseScheduledTeamSport';
import parseBasePlayerInfoTeamSport from './parseBasePlayerInfoTeamSport';

const parseNonScheduledBasketball = (
  pickWithLiveData: PickForEntry | PlayerDetail
): Partial<PlayerInfo> => {
  const isLive = pickWithLiveData.attributes.gameStatus === GameStatus.IN_PROGRESS;

  return {
    // playerActivities has stats for the current slate
    ...(pickWithLiveData.playerActivities && {
      meta: [
        {
          label: 'PTS',
          value: pickWithLiveData.playerActivities?.points ?? '-',
        },
        {
          label: 'REB',
          value: pickWithLiveData.playerActivities?.rebounds ?? '-',
        },
        {
          label: 'AST',
          value: pickWithLiveData.playerActivities?.assists ?? '-',
        },
      ],
    }),
    gameTime: (() => {
      if (!isLive) {
        return 'FINAL';
      }

      if (!pickWithLiveData.attributes.summary) return '-';
      return pickWithLiveData.attributes.summary.overtime
        ? 'OT'
        : `${pickWithLiveData.attributes.summary.clock} Q${pickWithLiveData.attributes.summary.quarter}`;
    })(),
  };
};

const parseNonScheduled = (pickWithLiveData: PickForEntry | PlayerDetail) => ({
  ...parseNonScheduledBasketball(pickWithLiveData),
  ...parseNonScheduledTeamSport(pickWithLiveData, true),
});

const parseBasketballPlayerInfo = (
  pick: PlayerPoolMember,
  pickWithLiveData?: PickForEntry
): Partial<PlayerInfo> => ({
  ...(pick.attributes.gameStatus === GameStatus.SCHEDULED || !pickWithLiveData
    ? parseScheduledTeamSport(pick)
    : parseNonScheduled(pickWithLiveData)),
  ...parseBasePlayerInfoTeamSport(pick),
});

export default parseBasketballPlayerInfo;

export { parseNonScheduled as parseBasketballPlayerInfoAfterGameStart };
